'use client'
import React from 'react'
import { BlockNumberComponent } from '../common/blockNumber'
import NetworkStatus from '@/hooks/useConnectionHealth'
import { DiscordIcon, TwitterIcon } from '@/utils/icons'
const Footer: React.FC = () => {
  return (
    <div className='fixed bottom-0 left-0 flex h-8 w-full items-center justify-between  sm:px-6 z-10 bg-primary'>
      <BlockNumberComponent />
      <div className='flex items-center justify-between'>
        <div className='flex items-center justify-between gap-2 mr-3'>
          <a
            href='https://discord.gg/ZwGBssxNCx'
            target='_blank'
            className='block px-2  text-sm text-white'
            role='menuitem'
            rel='noreferrer'
          >
            <DiscordIcon  className='text-white' />
          </a>
          <a
            href='https://x.com/Bubblefi_xyz'
            className='block px-2 text-sm text-white'
            role='menuitem'
          >
            <TwitterIcon className='text-white' />
          </a>
        </div>
        {/* <NetworkStatus /> */}
      </div>
    </div>
  )
}

export default Footer
